import { Box, Grow, makeStyles, Typography, Zoom } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import useCnaeContext from '../../contexts/CnaeContext';
import CnaeTitle from '../atoms/CnaeTitle';

const useStyles = makeStyles((theme) => ({

  container: {
    borderRadius: '8px',
    padding: '16px',
    cursor: 'pointer',
    width: '100%',
    '& .MuiTypography-subtitle2': {
      color: theme.palette.gray.main
    },
    '& .MuiTypography-body1': {
      color: theme.palette.gray.darkGray
    },
    marginBottom: '8px',

    '&:hover': {
      background: 'linear-gradient(0deg, #EBECF1, #EBECF1), linear-gradient(0deg, #F5F5F8, #F5F5F8), #FFFFFF'
    }
  },

  selected: {
    background: 'white',
    boxShadow: '0px 8px 12px rgba(9, 30, 66, 0.15), 0px 0px 1px rgba(9, 30, 66, 0.31)',

    '&:hover': {
      background: 'white'
    }
  }
}));

export default function CardCnae({ cnae, isSelected, onClick, timeout }) {
  const classes = useStyles();
  const { setCurrentCnae } = useCnaeContext();
  const { subclasse, descricao, simplesNacional } = cnae;

  function handleClickCard() {
    setCurrentCnae(cnae);
    onClick(true);
  }

  return (
    <Grow timeout={100} style={{ transitionDelay: `${timeout}ms` }} in>
      <Box
        className={clsx(classes.container, isSelected ? classes.selected : '')}
        onClick={() => handleClickCard()}
      >
        <CnaeTitle cnae={subclasse} status={simplesNacional}/>
        <Typography variant={'body1'} component={'p'} color={'inherit'}>
          {descricao}
        </Typography>
      </Box>
    </Grow>
  );
}

CardCnae.propTypes = {
  cnae: PropTypes.object,
  isSelected: PropTypes.bool,
  setSelected: PropTypes.func,
  onClick: PropTypes.func,
  timeout: PropTypes.number.isRequired
};
